export const TITLE_BG = 'transparent'
export const GET_TICKETS_BG = 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(2,0,36,1) 100%, rgba(4,48,70,1) 100%);'
export const CHECK_PRIZES_BG = 'linear-gradient(139.73deg, #313D5C 0%, #3D2A54 100%)'
export const FINISHED_ROUNDS_BG = 'linear-gradient(180deg, #CBD7EF 0%, #9A9FD0 100%)'
export const FINISHED_ROUNDS_BG_DARK = 'linear-gradient(180deg, #434575 0%, #66578D 100%)'
export const TRANSPARENT_BG = 'transparent'
